import { PageLoader } from '@/components'
import { useAuthContext } from '@/providers'
import { useCurrentPatient } from '@/services'
import { useIsDesktop, useModal } from '@/utils'
import { Navigate } from 'react-router-dom'
import { AddIcuDiary } from './AddIcuDiary'
import { DiaryArchive } from './DiaryArchive'
import { DiaryDesktop } from './DiaryDesktop'
import { DiaryTimeline } from './DiaryTimeline'

export const IcuDiaryPage = () => {
  const addState = useModal(false)
  const { currentPatient } = useAuthContext()
  const isDesktop = useIsDesktop()

  const { data, isLoading } = useCurrentPatient()

  if (isLoading) return <PageLoader />

  if (!data?.icu_diary_enabled) {
    // "../chat" statt "chat": relative Navigation ohne ".." haengt das Segment
    // an /icu-diary an und landet nur ueber die Catchall-Route irgendwo.
    // Diary-only-Stationen ohne Chat gehen aufs Dashboard (kein Dead-End).
    if (data?.chat_enabled === false) return <Navigate to="../dashboard" replace />
    return <Navigate to="../chat" replace />
  }

  // Entlassene Patient:innen sehen auf allen Geraeten das Archiv
  // (Buch-Ansicht mit Datums-Navigation und Druck/Export).
  if (!currentPatient?.active) return <DiaryArchive />

  // Desktop: Master-Detail über die volle Fensterbreite (Liste links,
  // Beitrag/Schreiben rechts). Mobile behält den bisherigen Flow.
  if (isDesktop) {
    return <DiaryDesktop canAdd={!currentPatient?.is_patient_user} />
  }

  // Show add entry view
  if (addState.isOpen) return <AddIcuDiary onClose={addState.close} />

  // Show active timeline view
  return <DiaryTimeline onAdd={addState.open} />
}
